
<div mat-dialog-content>
  <h1 class="customroom_link_header">Conference Room Links</h1>
    <div class="copylink_mainwrap">
        <div class="link_wrap signup_link">
          <p>Link For You </p>
          <div class="link_iconwrp">
            <span matTooltip="Copy link" (click)="copyClipBordFuntion('logedUser')">
                <i class="fas fa-link"></i>
            </span>
            <p>
                {{data.url+"/conference-room/"+data.room_key+"/"+data.log_in_Id._id+"?host=1"}}
            </p>
            <div class="copy_icon" matTooltip="Copy link" (click)="copyClipBordFuntion('logedUser')">
              <i class="fa-regular fa-copy"></i>
            </div>
          </div>
          <div mat-dialog-actions class="button_sesson">
          <button mat-button (click)="sessonStater()" >Start Session</button>
        </div>

        </div>
      </div>
      <!-- <div class="copylink_mainwrap">
        <div class="link_wrap signup_link">
          <p>Link For {{data.participent_id.fullname}}</p>
          <div class="link_iconwrp">
            <span matTooltip="Copy link" (click)="copyClipBordFuntion('participent')"
              ><i class="fas fa-link"></i
            ></span>
            <p>
                {{data.url+"/conference-room/"+data.room_key+"/"+data.participent_id._id+"?host="+data.log_in_Id._id}}
            </p>
            <div class="copy_icon" matTooltip="Copy link" (click)="copyClipBordFuntion('participent')">
              <i class="fa-regular fa-copy"></i>
            </div>
          </div>
        </div>
      </div> -->
</div>
<div mat-dialog-actions>
  <button mat-button (click)="this.dialogRef.close()" >Close</button>
</div>
